// extracted by css-extract-rspack-plugin
export default {"SidebarFooter":"Jitfm","HeaderButton":"R5p7D"};